import React from 'react';
import { Scale, Star, GitMerge, Users } from 'lucide-react';
export function CapturedContextExamples() {
  return;
}
function ContextCard({
  icon,
  title,
  quote,
  desc
}: {
  icon: React.ReactNode;
  title: string;
  quote: string;
  desc: string;
}) {
  return <div className="bg-gray-50 p-8 rounded-2xl border border-gray-100 hover:border-[#0066FF]/30 hover:shadow-lg transition-all duration-300 group" data-id="element-450">
      <div className="flex items-center gap-4 mb-6" data-id="element-451">
        <div className="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-600 group-hover:text-[#0066FF] group-hover:border-[#0066FF] transition-colors" data-id="element-452">
          {icon}
        </div>
        <h3 className="text-xl font-bold font-['Syne']" data-id="element-453">{title}</h3>
      </div>

      <div className="bg-white p-6 rounded-xl border border-gray-200 mb-4 italic text-gray-700 font-medium relative" data-id="element-454">
        <span className="absolute top-2 left-2 text-4xl text-gray-100 font-serif leading-none" data-id="element-455">
          "
        </span>
        <span className="relative z-10" data-id="element-456">{quote.replace(/"/g, '')}</span>
      </div>

      <p className="text-gray-600 pl-2 border-l-2 border-[#0066FF]" data-id="element-457">{desc}</p>
    </div>;
}